import { useEffect, useRef } from "react";
import "./VolumeSlider.css";

interface VolumeSliderProps {
  volume: number;
  onVolumeChange: (volume: number) => void;
}

const VolumeSlider = ({ volume, onVolumeChange }: VolumeSliderProps) => {
  const sliderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  const handleMouseMove = (e: MouseEvent) => {
    if (sliderRef.current) {
      const rect = sliderRef.current.getBoundingClientRect();
      const moveX = e.clientX - rect.left;
      const sliderWidth = rect.width;
      const newVolume = Math.max(0, Math.min(1, moveX / sliderWidth));
      onVolumeChange(newVolume);
    }
  };

  const handleMouseUp = () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const handleSliderClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (sliderRef.current) {
      const rect = sliderRef.current.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const sliderWidth = rect.width;
      const newVolume = Math.max(0, Math.min(1, clickX / sliderWidth));
      onVolumeChange(newVolume);
    }
  };

  const handleMouseDown = () => {
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <div
      ref={sliderRef}
      className="custom-volume-slider"
      onClick={handleSliderClick}
      onMouseDown={handleMouseDown}
      aria-label="Volume slider"
    >
      <div className="slider-track">
        <div className="slider-fill" style={{ width: `${volume * 100}%` }} />
      </div>
    </div>
  );
};

export default VolumeSlider;
